/**
 * Mapping from BCP 47 primary language subtags to OpenType language system tags.
 *
 * Generated from:
 *   - OpenType language system tag registry (Microsoft)
 *   - IANA BCP 47 subtag registry
 *
 * Source: https://learn.microsoft.com/en-us/typography/opentype/spec/languagetags
 *
 * Do not edit manually. Regenerate with: node scripts/generate-language-tags.ts
 */

const langSysTagMap = {
  aa: 'AFR',
  ab: 'ABK',
  af: 'AFK',
  ak: 'AKA',
  am: 'AMH',
  an: 'ARG',
  ar: 'ARA',
  as: 'ASM',
  av: 'AVR',
  ay: 'AYM',
  az: 'AZE',
  ba: 'BSH',
  be: 'BEL',
  bg: 'BGR',
  bi: 'BIS',
  bm: 'BMB',
  bn: 'BEN',
  bo: 'TIB',
  br: 'BRE',
  bs: 'BOS',
  ca: 'CAT',
  ce: 'CHE',
  ch: 'CHA',
  co: 'COS',
  cr: 'CRE',
  cs: 'CSY',
  cu: 'CSL',
  cv: 'CHU',
  cy: 'WEL',
  da: 'DAN',
  de: 'DEU',
  dv: 'DIV',
  dz: 'DZN',
  ee: 'EWE',
  el: 'ELL',
  en: 'ENG',
  eo: 'NTO',
  es: 'ESP',
  et: 'ETI',
  eu: 'EUQ',
  fa: 'FAR',
  ff: 'FUL',
  fi: 'FIN',
  fj: 'FJI',
  fo: 'FOS',
  fr: 'FRA',
  fy: 'FRI',
  ga: 'IRI',
  gd: 'GAE',
  gl: 'GAL',
  gn: 'GUA',
  gu: 'GUJ',
  gv: 'MNX',
  ha: 'HAU',
  he: 'IWR',
  hi: 'HIN',
  ho: 'HMO',
  hr: 'HRV',
  ht: 'HAI',
  hu: 'HUN',
  hy: 'HYE',
  hz: 'HER',
  ia: 'INA',
  id: 'IND',
  ie: 'ILE',
  ig: 'IBO',
  ii: 'YIM',
  ik: 'IPK',
  io: 'IDO',
  is: 'ISL',
  it: 'ITA',
  iu: 'INU',
  ja: 'JAN',
  jv: 'JAV',
  ka: 'KAT',
  ki: 'KIK',
  kj: 'KUA',
  kk: 'KAZ',
  kl: 'GRN',
  km: 'KHM',
  kn: 'KAN',
  ko: 'KOR',
  kr: 'KNR',
  ks: 'KSH',
  ku: 'KUR',
  kv: 'KOM',
  kw: 'COR',
  ky: 'KIR',
  la: 'LAT',
  lb: 'LTZ',
  lg: 'LUG',
  li: 'LIM',
  ln: 'LIN',
  lo: 'LAO',
  lt: 'LTH',
  lu: 'LUB',
  lv: 'LVI',
  mg: 'MLG',
  mh: 'MAH',
  mi: 'MRI',
  mk: 'MKD',
  ml: 'MAL',
  mn: 'MNG',
  mr: 'MAR',
  ms: 'MLY',
  mt: 'MTS',
  my: 'BRM',
  na: 'NAU',
  nb: 'NOR',
  nd: 'NDB',
  ne: 'NEP',
  ng: 'NDG',
  nl: 'NLD',
  nn: 'NYN',
  no: 'NOR',
  nr: 'NDB',
  nv: 'NAV',
  ny: 'CHI',
  oc: 'OCI',
  oj: 'OJB',
  om: 'ORO',
  or: 'ORI',
  os: 'OSS',
  pa: 'PAN',
  pi: 'PAL',
  pl: 'PLK',
  ps: 'PAS',
  pt: 'PTG',
  qu: 'QUZ',
  rm: 'RMS',
  rn: 'RUN',
  ro: 'ROM',
  ru: 'RUS',
  rw: 'RUA',
  sa: 'SAN',
  sc: 'SRD',
  sd: 'SND',
  se: 'NSM',
  sg: 'SGO',
  sh: 'BOS',
  si: 'SNH',
  sk: 'SKY',
  sl: 'SLV',
  sm: 'SMO',
  so: 'SML',
  sq: 'SQI',
  sr: 'SRB',
  ss: 'SWZ',
  st: 'SOT',
  su: 'SUN',
  sv: 'SVE',
  sw: 'SWK',
  ta: 'TAM',
  te: 'TEL',
  tg: 'TAJ',
  th: 'THA',
  ti: 'TGY',
  tk: 'TKM',
  tl: 'TGL',
  tn: 'TNA',
  to: 'TGN',
  tr: 'TRK',
  ts: 'TSG',
  tt: 'TAT',
  tw: 'TWI',
  ty: 'THT',
  ug: 'UYG',
  uk: 'UKR',
  ur: 'URD',
  uz: 'UZB',
  ve: 'VEN',
  vi: 'VIT',
  vo: 'VOL',
  wa: 'WLN',
  wo: 'WLF',
  xh: 'XHS',
  yi: 'JII',
  yo: 'YBA',
  za: 'ZHA',
  zh: 'ZHS',
  zu: 'ZUL',
} as const;

type LangKey = keyof typeof langSysTagMap;

/**
 * Map a BCP 47 language tag to an OpenType language system tag.
 * Only the primary language subtag (the part before the first hyphen)
 * is used for the lookup.
 * Returns `undefined` for unmapped languages.
 */
export function languageToOpenTypeTag(language: string): string | undefined {
  const primary = language.split('-')[0].toLowerCase() as LangKey;
  return langSysTagMap[primary];
}
